import router from '@/router/index'
import {noTokenRequest, http} from "@/config/httpCommon";

export default   {
    state:{
        token:'',
        permissions: [],
        company: null,
        user: null,
        role:null,
        userFactories:[],
    },
    getters: {
        isAuthenticated: (state) => state.token || localStorage.getItem("access_token"),
        permissions: (state) => state.permissions,
        company: (state) => state.company || JSON.parse(localStorage.getItem("company")),
        userRole: (state) => state.role || JSON.parse(localStorage.getItem("role")),
        roleName: (state) => {
            const role = state.role || JSON.parse(localStorage.getItem("role"))
            return role? role.name.toLowerCase() : ''
        },
        user: (state) => state.user || JSON.parse(localStorage.getItem("user")),
        userFactoriesOptions: (state) => {
            let userFactories = [];
            state.userFactories.forEach((factory)=>{
                userFactories.push({'value':factory.id, 'label':factory.name})
            })
            return userFactories;
        }
    },
    mutations: {
        AUTH_SUCCESS(state, payload) {
            state.token = payload;
        },
        AUTH_PERMISSIONS(state, payload) {
            state.permissions = payload
        },
        ADD_USER_FACTORIES(state, payload){
            state.userFactories = payload;
        },
        SET_AUTH_USER(state,payload){
            state.user = payload;
        },
        SET_AUTH_ROLE(state, payload) {
            state.role = payload;
        }
    },
    actions:{
        setAuthPermissions({commit}, payload) {
            commit('AUTH_PERMISSIONS', payload)
        },
        async getUserFactories({commit}) {
            let res = await http.get(`user-factories`);
            commit('ADD_USER_FACTORIES', res.data)
            return res;
        }
    }
}